module.exports = __webpack_public_path__ + "img/huarong.fbac1cd2.png";